module.exports = __webpack_public_path__ + "static/banglacamp-acb0bb44c59a979b429c33c999191de9.jpg";